const state = {
	isFold:false
}

export default state